import { render, staticRenderFns } from "./InboundTransferBatchDetails.template.vue?vue&type=template&id=74836605&scoped=true&"
var script = {}
import style0 from "./InboundTransferBatchDetails.template.vue?vue&type=style&index=0&id=74836605&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74836605",
  null
  
)

export default component.exports